import styled from '@emotion/styled';

export const Paragraf = styled.p`
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: #fff;
  margin-bottom: 20px;

  @media (min-width: 1440px) {
    text-align: left;
    max-width: 528px;
    font-size: 16px;
    margin-bottom: 48px;
  }
`;
